$(document).ready(function () {
    $(".checks-task").show()
    const DescriptionTextArea = document.getElementById('description');
    focusTextArea(DescriptionTextArea)

    $("#table-tasks").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': '/get-task-by-user',
        'columns': [{data: 'id'}, {data: 'description'}, {data: 'client_name'}, {data: 'department'},],
        "columnDefs": [
            {
                "targets": 4,
                "render": function (data, type, row, meta) {
                    btn_update_task = buttonStartTask(row.id,row.status_id,)
                    btn_edit_task = buttonEditTask(row.id,row.status_id)
                    return btn_edit_task + btn_update_task
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })

    $("#add-task").on('click', function (e) {
        e.preventDefault()
        $(".checks-task").show()
        clearFields()
        $('.item-postpone').prop('checked', true);
        $(".title-taks").html('Agregar tarea')
        $("#modal-task").modal('show')
    })

    $("#table-tasks").on('click', '.edit-task', function (e) {
        e.preventDefault()
        $(".title-taks").html('Editar tarea')
        let list_task = $("#table-tasks").DataTable()
        let row = list_task.row($(this).parents('tr')).data()
        taskUpdateModal(row)
        $("#modal-task").modal('show')
        $(".checks-task").hide()
    })

    $("#table-tasks tbody").on('click','.start-task', function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('id',$(this).data('id'))
        $(".loader_").addClass('loading')
        sendData(data,'/start-task')
    })

    $("#table-tasks tbody").on('click','.add-solution',function (e){
        e.preventDefault()
        $(".item-name-solution").val($(this).data('id'))
        const SolutionTextArea = document.getElementById('solution');
        const textLength = SolutionTextArea.value.length;
        SolutionTextArea.setSelectionRange(textLength, textLength);
        $("#modal-solution").modal('show');
    })

    $("#form-task").on('submit', function (e) {
        e.preventDefault()
        clearSpan()
        let data = new FormData(this)
        $(".loader_").addClass('loading')
        sendData(data, '/sent-value-task','modal-task')
    })

    $("#form-solution").on('submit', function (e) {
        e.preventDefault()
        Swal.fire({
            title: '¿Finalizar tarea? ',
            text: "Al finalizar la tarea, no podras editar la solución.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar.',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            let data = new FormData(this)
            $(".loader_").addClass('loading')
            sendData(data, '/add-solution','modal-solution')
        })

    })

    function sendData(data, route, modal) {
        $.ajax({
            url: route, type: 'POST', data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (data) {
                setTimeout(function () {
                    alertSuccess(data.msg)
                    $("#"+modal).modal('hide')
                    $("#table-tasks").DataTable().ajax.reload();
                    $(".loader_").removeClass('loading')
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass('loading')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-error-" + index).text(value);
                });
            }
        });
    }

    function taskUpdateModal(row) {
        $.each(row, function (index, value) {
            $(".item-" + index).val(value)
        })
    }

    function focusTextArea(DescriptionTextArea) {
        if (DescriptionTextArea) {
            DescriptionTextArea.addEventListener('click', () => {
                DescriptionTextArea.focus();
                const textLength = DescriptionTextArea.value.length;
                DescriptionTextArea.setSelectionRange(textLength, textLength);
            })
        }
    }

    function clearFields() {
        $(".item-id").val('')
        $(".item-description").val('')
        $(".item-client_name").val('')
        $(".item-department").val('')
        $(".item-company").val('')
    }

    function clearSpan() {
        $(".item-error-description").text('')
        $(".item-error-client_name").text('')
        $(".item-error-department").text('')
        $(".item-error-company").text('')
        $(".item-error-start").text('')
    }

    function buttonStartTask(id,status_id,) {
        if (status_id == 1) {
            return '<button data-toggle="tooltip" data-placement="top" title="Iniciar tarea" ' +
                'class="btn btn-success start-task btn-sm m-1"' + 'data-id ="' + id + '">' +
                '<i class="fa-solid fa-play"></i>' +
                '</button>'
        }
        if (status_id == 2) {
            return '<button data-toggle="tooltip" data-placement="top" title="Agregar solución" ' +
                'class="btn btn-info add-solution btn-sm m-1"' + 'data-id ="' + id + '">' +
                '<i class="fas fa-flag-checkered"></i>' +
                '</button>'
        }
        return "";
    }

    function buttonEditTask(id,status_id) {
        if (status_id == 3) {
            return '<button data-toggle="tooltip" data-placement="top" title="Ver tarea" ' +
                'class="btn btn-info show-task btn-sm m-1"' + 'data-id ="' + id + '">' +
                '<i class="far fa-eye"></i>' +
                '</button>'
        }
        if (status_id !== 3) {
            return '<button data-toggle="tooltip" data-placement="top" title="Editar tarea" ' +
                'class="btn btn-primary edit-task btn-sm m-1"' + 'data-id ="' + id + '">' +
                '<i class="far fa-edit"></i>' +
                '</button>'
        }
    }

});

